// extracted by mini-css-extract-plugin
export var border = "_27-8";
export var brand = "_27-t";
export var button = "_27-l";
export var center = "_27-a";
export var centered = "_27-6";
export var closeButton = "_27-c";
export var disabledWrapper = "_27-m";
export var error = "_27-p";
export var extraLarge = "_27-4";
export var extraSmall = "_27-1";
export var fill = "_27-i";
export var footer = "_27-h";
export var footerAction = "_27-j";
export var footerButtons = "_27-k";
export var header = "_27-7";
export var headerWithClose = "_27-d";
export var icon = "_27-o";
export var info = "_27-s";
export var inline = "_27-9";
export var large = "_27-3";
export var main = "_27-e";
export var modal = "_27-0";
export var nearFull = "_27-5";
export var neutral = "_27-u";
export var noPadding = "_27-g";
export var none = "_27-v";
export var scrollable = "_27-f";
export var small = "_27-2";
export var success = "_27-r";
export var tight = "_27-n";
export var titleIcon = "_27-b";
export var warn = "_27-q";